import React, { FC, useState } from 'react';

const SftpStatusGuide: FC = () => {
    const [open, setOpen] = useState(false);

    return (
        <div className="rounded-md border border-slate-200 bg-slate-50 text-sm text-slate-700">
            <button
                type="button"
                className="flex w-full items-center justify-between px-3 py-2 font-medium text-slate-800 hover:bg-slate-100"
                onClick={() => setOpen((v) => !v)}
            >
                Transfer status guide
                <span className="text-xs text-slate-500">{open ? 'Hide' : 'Show'}</span>
            </button>
            {open && (
                <div className="space-y-3 border-t border-slate-200 px-3 py-3">
                    <p>
                        Files are picked up every <strong>5 minutes</strong> (when SFTP is enabled) or when you click{' '}
                        <strong>Download files</strong>. After download, validation runs automatically.
                    </p>
                    <table className="w-full text-left text-xs">
                        <thead>
                            <tr className="border-b border-slate-200 text-slate-500">
                                <th className="py-1 pr-2">Status</th>
                                <th className="py-1 pr-2">Schema</th>
                                <th className="py-1">What to do</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100">
                            <tr>
                                <td className="py-1 pr-2 font-medium">Downloaded</td>
                                <td className="py-1 pr-2">—</td>
                                <td className="py-1">Validation did not finish — open Detail → Re-run validation</td>
                            </tr>
                            <tr>
                                <td className="py-1 pr-2 font-medium">Awaiting admin input</td>
                                <td className="py-1 pr-2">Valid</td>
                                <td className="py-1">Fill staging → Approve or Reject</td>
                            </tr>
                            <tr>
                                <td className="py-1 pr-2 font-medium">Validation failed / Failed</td>
                                <td className="py-1 pr-2">Invalid</td>
                                <td className="py-1">Fix XML → Re-run validation on Detail</td>
                            </tr>
                            <tr>
                                <td className="py-1 pr-2 font-medium">Rejected / Processed</td>
                                <td className="py-1 pr-2">—</td>
                                <td className="py-1">Closed — no further actions</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default SftpStatusGuide;
